import { render, staticRenderFns } from "./NotificationModule.vue?vue&type=template&id=f2f2afee&scoped=true"
import script from "./NotificationModule.vue?vue&type=script&lang=js"
export * from "./NotificationModule.vue?vue&type=script&lang=js"
import style0 from "./NotificationModule.vue?vue&type=style&index=0&id=f2f2afee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f2afee",
  null
  
)

export default component.exports